import reference_config from "@/components/Reference/config";

export default {
  storeNamespace: 'business_return',
  authFeature: 'business-return',
  newRouteName: 'BusinessReturnMobileNew',
  listRouteName: "BusinessReturnMobileList",
  editRouteName: "BusinessReturnMobileEdit",
  detailRouteName: "BusinessReturnMobileDetail",
  formComponentName: 'BusinessReturnMobileForm',
  redirectAfterCreateRouteName:'BusinessReturnMobileDetail',
  redirectAfterCreateRouteParams: 'id',
  fields: [
    {
      name: 'agency_number',
      label: "Agence",
      type: 'select',
      inForm: true,
      required: true,
    },
    {
      name: 'business_number',
      label: "Affaire",
      type: 'select',
      inForm: true,
      required: false,
      firstOption: "-- Sélectionnez une agence --",
    },
    {
      // Entrepôt où le matériel est déposé : par défaut celui de l'opérateur connecté.
      name: 'return_warehouse_id',
      label: "Entrepôt de dépôt",
      type: 'select',
      inForm: true,
      required: true,
      firstOption: "-- Sélectionnez un entrepôt --",
    },
    {
      name: 'unique_references',
      label: "Références uniques",
      type: 'group_repeater',
      inForm: true,
      required: true,
      disableAdd: true,
      fields: [
        {
          name: 'id',
          type: 'text',
          inForm: true,
          required: true,
          readonly: true
        },
        {
          name: 'name',
          type: 'text',
          inForm: true,
          required: true,
          readonly: true
        }
      ]
    },
    {
      name: 'comment',
      label: "Merci de décrire précisément votre conditionnement",
      type: 'textarea',
      inForm: true,
      required: false,
    },
    {
      name: 'failure_warning_comment',
      label: "Merci de nous signaler si l'un ou plusieurs de ces matériels sont en panne",
      type: 'textarea',
      inForm: true,
      required: false,
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/BusinessReturnMobile/config.js